import script from "./LiveCasinoSpins.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveCasinoSpins.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__